









































import {
  computed,
  defineComponent,
  toRefs,
  PropType
} from '@nuxtjs/composition-api'
import {
  USER_AGENT_NS,
  UserAgentState
} from '~/store/modules/shared/userAgent/state'
import { useNamespacedStore } from '~/compositions/store'

export default defineComponent({
  props: {
    active: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    button: { type: Boolean, default: false },
    borderBottomOnly: { type: Boolean, default: false },
    href: { type: String, default: null },
    target: { type: String, default: '_self' },
    to: {
      type: [Object, String],
      default: null
    },
    variant: {
      type: String as PropType<'primary' | 'warning' | 'danger'>,
      default: 'primary'
    },
    replace: { type: Boolean, default: false },
    itemWrapperClass: { type: String, default: null },
    tag: { type: String, default: 'div' },
    noPadding: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { disabled, button, href, to, variant, tag } = toRefs(props)
    const { getters: userAgentGetters } = useNamespacedStore<UserAgentState>(
      USER_AGENT_NS
    )
    const isMobile = computed(() => userAgentGetters('isMobile'))
    const variantClass = computed(() => {
      if (variant.value === 'warning') {
        return 'tw-bg-yellow-200 !tw-text-yellow-900 hover:tw-bg-yellow-300 '
      } else if (variant.value === 'danger') {
        return 'tw-bg-red-200 !tw-text-red-900 hover:tw-bg-red-300 '
      }
    })
    const componentType = computed(() => {
      if (button.value) {
        return 'CButton'
      } else if (href.value || to.value) {
        return 'CLink'
      }
      return tag.value
    })
    const handleClick = (e: Event) => {
      if (!disabled.value) {
        emit('click', e)
      }
    }

    return {
      handleClick,
      componentType,
      variantClass,
      isMobile
    }
  }
})
